/**
 * Défilement adouci du site — initialisation de Lenis.
 *
 * La bibliothèque est chargée juste avant (assets/lenis.min.js) et expose
 * `window.Lenis`. Ce fichier ne fait que la configurer pour ce thème.
 *
 * Trois refus volontaires, chacun pour une raison précise :
 *   - « mouvement réduit » : le défilement adouci est exactement ce que ce
 *     réglage système demande d'éviter ;
 *   - l'éditeur de thème : Shopify y fait défiler lui-même jusqu'à la section
 *     sélectionnée, deux mécaniques qui se disputent le défilement donnent un
 *     aperçu imprévisible ;
 *   - la bibliothèque absente : on retombe alors sur le défilement natif, sans
 *     rien casser.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!window.Lenis || !script) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  /**
   * Un conteneur qui défile vraiment garde la main sur la molette.
   *
   * Lenis appelle cette fonction pour chaque nœud du trajet de l'évènement, de
   * la cible vers la racine. Sans elle, le panier, le menu et les fenêtres se
   * retrouveraient figés : la molette ferait défiler la page derrière eux.
   *
   * L'ordre des tests compte : `scrollHeight` est bien moins coûteux que
   * `getComputedStyle`, et il élimine déjà la grande majorité des nœuds.
   *
   * @param {Node} node
   * @returns {boolean}
   */
  function prevent(node) {
    if (!(node instanceof Element)) return false;
    if (node.hasAttribute('data-lenis-prevent')) return true;
    if (node.scrollHeight <= node.clientHeight + 1) return false;

    var overflow = window.getComputedStyle(node).overflowY;
    return overflow === 'auto' || overflow === 'scroll';
  }

  var lerp = parseFloat(script.dataset.lerp);
  if (!(lerp > 0 && lerp <= 1)) lerp = 0.1;

  var lenis = new window.Lenis({
    lerp: lerp,
    /* Le doigt garde le défilement natif : le forcer donne une sensation de
       retard et se bat avec les carrousels horizontaux. */
    syncTouch: script.dataset.touch === 'true',
    /* Lenis prend en charge les liens d'ancrage lui-même. */
    anchors: true,
    /* Sa propre boucle d'animation : inutile d'en tenir une de notre côté. */
    autoRaf: true,
    prevent: prevent,
  });

  /* Rendu accessible pour un défilement programmé : lenis.scrollTo(cible). */
  window.ihsLenis = lenis;
})();
